// Constants and configuration for customer list

export const PAGINATION_CONFIG = {
  CUSTOMERS_PER_PAGE: 50,
  DEFAULT_PAGE: 1,
  MAX_PAGINATION_BUTTONS: 5
};

export const SEARCH_CONFIG = {
  DEBOUNCE_DELAY: 300,
  MIN_SEARCH_LENGTH: 0
};

export const NOTIFICATION_CONFIG = {
  AUTO_DISMISS_DELAY: 4000
};

export const SORT_CONFIG = {
  DEFAULT_SORT_BY: 'last_activity_at',
  DEFAULT_SORT_ORDER: 'DESC'
};

export const DEFAULT_PAGINATION = {
  page: 1,
  limit: PAGINATION_CONFIG.CUSTOMERS_PER_PAGE,
  total: 0,
  pages: 0
};

export const IMPORT_STATES = {
  IDLE: 'idle',
  IMPORTING: 'importing',
  COMPLETED: 'completed',
  ERROR: 'error'
};

export const USER_ROLES = {
  FRANCHISEE: 'franchisee',
  TECHNICIAN: 'technician',
  ADMIN: 'admin'
};